import React, { use, useState, useEffect, useRef } from 'react';
import {
  ArrowLeft,
  Star,
  Phone,
  Navigation,
  MessageCircle,
  ChevronLeft,
  ChevronRight,
  X,
  Share2,
  MapPin,
  ExternalLink,
  Clock,
  Globe2Icon,
} from 'lucide-react';
import { Pencil } from 'lucide-react';
import { BsGlobe } from 'react-icons/bs';
import { useLocation } from 'react-router-dom';
import SocialIconModal from './SocialIconModal';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

const RudeLounge = () => {
  const [activeTab, setActiveTab] = useState('Ambience');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isOffersModalOpen, setIsOffersModalOpen] = useState(false);
  const [currentOfferIndex, setCurrentOfferIndex] = useState(0);
  const [islocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [isTimingModalOpen, setIsTimingModalOpen] = useState(false);
  const [offersData, setOffersData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editComment, setEditComment] = useState('');
  const [editRating, setEditRating] = useState(0);
  const [venueRatings, setVenueRatings] = useState({
    comments: [],
  });
  const [venueDetails, setVenueDetails] = useState({});
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const ratingsRef = useRef(null); // Add this ref
  const location = useLocation();
  const [socialModal, setSocialModal] = useState({
    isOpen: false,
    socialName: '',
    href: '',
  });

  const openSocialModal = (name, href) => {
    setSocialModal({
      isOpen: true,
      socialName: name,
      href: href,
    });
  };
  const closeSocialModal = () => {
    setSocialModal({ ...socialModal, isOpen: false });
  };

  // Add state for gallery data
  const [galleryData, setGalleryData] = useState({
    Ambience: [],
    Menu: [],
    Food: [],
  });

  useEffect(() => {
    // Check for scrollToRatings param
    const params = new URLSearchParams(location.search);
    if (params.get('scrollToRatings') === '1' && ratingsRef.current) {
      setTimeout(() => {
        ratingsRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 300); // slight delay to ensure DOM is ready
    }
  }, [location]);

  useEffect(() => {
    if (location.state?.scrollToPhotos && location.state?.openMenuTab) {
      // Set active tab to Menu
      setActiveTab('Menu');

      // Scroll to photos section after a short delay
      setTimeout(() => {
        const gallerySection = document.getElementById('gallery-section');
        if (gallerySection) {
          gallerySection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.state]);

  useEffect(() => {
    const getPhotos = async () => {
      const venueId = localStorage.getItem('venueId');
      const token = localStorage.getItem('tringAuthToken');

      if (!venueId || !token) {
        console.error('Missing venue ID or token.');
        return;
      }

      try {
        const response = await fetchWithAuth(
          `${API_ENDPOINTS.VENUE_PHOTOS(venueId)}?limit=100`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        const Ambience = data.photos.filter(
          item => item.photoType === 'ambience'
        );
        const Food = data.photos.filter(item => item.photoType === 'food');
        const menu = data.photos.filter(item => item.photoType === 'menu');

        // Update state instead of mutating object
        setGalleryData({
          Ambience: Ambience,
          Menu: menu,
          Food: Food,
        });
      } catch (error) {
        console.error('Failed to fetch photos:', error);
      }
    };
    const getoffers = async () => {
      const venueId = localStorage.getItem('venueId');
      const token = localStorage.getItem('tringAuthToken');
      if (!venueId || !token) {
        console.error('Missing venue ID or token.');
        return;
      }
      try {
        const response = await fetchWithAuth(
          `${API_ENDPOINTS.VENUE_OFFERS(venueId)}?limit=100`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          console.error('Failed to fetch offers:', response.status);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setOffersData(data.offers);
      } catch (error) {
        console.error('Failed to fetch offers:', error);
      }
    };

    const getvenuedetails = async () => {
      const venueId = localStorage.getItem('venueId');
      const token = localStorage.getItem('tringAuthToken');
      if (!venueId || !token) {
        console.error('Missing venue ID or token.');
        return;
      }
      try {
        const response = await fetchWithAuth(
          API_ENDPOINTS.VENUE_BY_ID(venueId),
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setVenueDetails(data);
        console.log(venueDetails);

        // You can use the venue details as needed
      } catch (error) {
        console.error('Failed to fetch venue details:', error);
      }
    };
    getvenuedetails();
    getoffers();
    getPhotos();
  }, []);

  const handleCancelEdit = () => {
    setEditMode(false);
    setEditComment('');
    setEditRating(0);
  };
  const scrollToRatings = () => {
    if (ratingsRef.current) {
      ratingsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const renderStars = value => {
    const stars = [];
    const rating = parseFloat(value) || 0;
    for (let i = 1; i <= 5; i++) {
      let fill = '#E0E0E0';
      if (i <= Math.floor(rating)) fill = '#FFD700';
      else if (i - rating < 1 && i > rating) fill = `url(#half${i})`;
      stars.push(
        <svg key={i} width="20" height="20" viewBox="0 0 20 20">
          <defs>
            <linearGradient id={`half${i}`}>
              <stop
                offset={`${(rating - Math.floor(rating)) * 100}%`}
                stopColor="#FFD700"
              />
              <stop
                offset={`${(rating - Math.floor(rating)) * 100}%`}
                stopColor="#E0E0E0"
              />
            </linearGradient>
          </defs>
          <polygon
            points="10,1 12.59,7.36 19.51,7.36 13.96,11.63 16.55,17.99 10,13.72 3.45,17.99 6.04,11.63 0.49,7.36 7.41,7.36"
            fill={
              i <= Math.floor(rating)
                ? '#FFD700'
                : i - rating < 1 && i > rating
                  ? `url(#half${i})`
                  : '#E0E0E0'
            }
          />
        </svg>
      );
    }
    return <span style={{ display: 'flex', gap: '2px' }}>{stars}</span>;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const venueId = localStorage.getItem('venueId');
    const token = localStorage.getItem('tringAuthToken');
    try {
      const response = await fetchWithAuth(API_ENDPOINTS.RATINGS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          rating: rating,
          comment: comment,
          venueId: venueId,
        }),
      });
      setRating(0);
      setComment('');
      setHover(0);
      if (!response.ok) {
        console.error('Failed to submit rating:', response.status);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
    } catch (error) {
      console.error('Failed to submit rating:', error);
    }
  };

  const locationData = {
    name: (venueDetails?.name ?? '') + ' ' + (venueDetails?.display_name ?? ''),
    address: venueDetails.address?.formatted_address ?? 'Address not available',

    phone: venueDetails.socialLinks?.contactNumber ?? '+91 0000000000',
    coordinates: {
      lat: venueDetails.geometry?.coordinates?.[1] ?? 0, // latitude
      lng: venueDetails.geometry?.coordinates?.[0] ?? 0, // longitude
    },
  };

  // Timing data
  const dayMap = {
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun',
  };
  const isOpenAllDays =
    !venueDetails.daysOpen || venueDetails.daysOpen.length === 0;

  // Get current day
  const getCurrentDay = () => {
    const days = [
      'sunday',
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
    ];
    const today = new Date().getDay();
    return days[today];
  };

  // Update the timingData object to use default values when no time is available
  const timingData = {
    monday: {
      open: venueDetails?.openTime || '12pm', // Default to 12pm if no time
      close: venueDetails?.closeTime || '2am', // Default to 2am if no time
      isOpen:
        (isOpenAllDays ||
          (venueDetails?.daysOpen ?? []).includes(dayMap.monday)) &&
        (venueDetails?.openTime || venueDetails?.closeTime), // Consider open if either time exists
    },
    tuesday: {
      open: venueDetails?.openTime || '12pm',
      close: venueDetails?.closeTime || '2am',
      isOpen:
        (isOpenAllDays ||
          (venueDetails?.daysOpen ?? []).includes(dayMap.tuesday)) &&
        (venueDetails?.openTime || venueDetails?.closeTime),
    },
    wednesday: {
      open: venueDetails?.openTime || '12pm',
      close: venueDetails?.closeTime || '2am',
      isOpen:
        (isOpenAllDays ||
          (venueDetails?.daysOpen ?? []).includes(dayMap.wednesday)) &&
        (venueDetails?.openTime || venueDetails?.closeTime),
    },
    thursday: {
      open: venueDetails?.openTime || '12pm',
      close: venueDetails?.closeTime || '2am',
      isOpen:
        (isOpenAllDays ||
          (venueDetails?.daysOpen ?? []).includes(dayMap.thursday)) &&
        (venueDetails?.openTime || venueDetails?.closeTime),
    },
    friday: {
      open: venueDetails?.openTime || '12pm',
      close: venueDetails?.closeTime || '2am',
      isOpen:
        (isOpenAllDays ||
          (venueDetails?.daysOpen ?? []).includes(dayMap.friday)) &&
        (venueDetails?.openTime || venueDetails?.closeTime),
    },
    saturday: {
      open: venueDetails?.openTime || '12pm',
      close: venueDetails?.closeTime || '2am',
      isOpen:
        (isOpenAllDays ||
          (venueDetails?.daysOpen ?? []).includes(dayMap.saturday)) &&
        (venueDetails?.openTime || venueDetails?.closeTime),
    },
    sunday: {
      open: venueDetails?.openTime || '12pm',
      close: venueDetails?.closeTime || '2am',
      isOpen:
        (isOpenAllDays ||
          (venueDetails?.daysOpen ?? []).includes(dayMap.sunday)) &&
        (venueDetails?.openTime || venueDetails?.closeTime),
    },
  };

  // Update the isCurrentlyOpen function to use the default times
  const isCurrentlyOpen = () => {
    const currentDay = getCurrentDay();
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    const currentMinute = currentTime.getMinutes();

    // Get opening and closing times for current day (or defaults)
    const { open, close, isOpen } = timingData[currentDay];

    if (!isOpen) return false;

    // Parse opening time (default format is "12pm")
    const openHour = parseInt(open) || 12; // Default to 12 if parsing fails
    const isOpenPM = open.toLowerCase().includes('pm') && openHour !== 12;
    const open24Hour = isOpenPM ? openHour + 12 : openHour;

    // Parse closing time (default format is "2am")
    const closeHour = parseInt(close) || 2; // Default to 2 if parsing fails
    const isCloseAM = close.toLowerCase().includes('am');
    const close24Hour = isCloseAM
      ? closeHour === 12
        ? 0
        : closeHour // 12am becomes 0
      : closeHour === 12
        ? 12
        : closeHour + 12;

    // Check if current time is within opening hours
    if (close24Hour > open24Hour) {
      // Normal case (e.g., 12pm-2am)
      return currentHour >= open24Hour || currentHour < close24Hour;
    } else {
      // Special case when closing is next day (e.g., 10pm-2am)
      return currentHour >= open24Hour || currentHour < close24Hour;
    }
  };

  const currentGallery = galleryData[activeTab];

  const openModal = index => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex(prev =>
      prev === currentGallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex(prev =>
      prev === 0 ? currentGallery.length - 1 : prev - 1
    );
  };

  const handleTabChange = tab => {
    setActiveTab(tab);
    setCurrentImageIndex(0);
  };

  const openOffersModal = () => {
    if (offersData && offersData.length > 0) {
      setIsOffersModalOpen(true);
      setCurrentOfferIndex(0);
    }
  };

  const openLocationModal = () => {
    setIsLocationModalOpen(true);
  };

  const openTimingModal = () => {
    setIsTimingModalOpen(true);
  };

  const closeLocationModal = () => {
    setIsLocationModalOpen(false);
  };

  const closeOffersModal = () => {
    setIsOffersModalOpen(false);
  };

  const closeTimingModal = () => {
    setIsTimingModalOpen(false);
  };

  const nextOffer = () => {
    setCurrentOfferIndex(prev =>
      prev === offersData.length - 1 ? 0 : prev + 1
    );
  };

  const prevOffer = () => {
    setCurrentOfferIndex(prev =>
      prev === 0 ? offersData.length - 1 : prev - 1
    );
  };

  // Touch handlers for swipe functionality
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const onTouchStart = e => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextOffer();
    }
    if (isRightSwipe) {
      prevOffer();
    }
  };

  const openGoogleMaps = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=${locationData.coordinates.lat},${locationData.coordinates.lng}`;
    window.open(url, '_blank');
  };

  const openAppleMaps = () => {
    const url = `http://maps.apple.com/?q=${locationData.coordinates.lat},${locationData.coordinates.lng}`;
    window.open(url, '_blank');
  };

  // --- Call & WhatsApp Button Functionality ---
  const handleCall = () => {
    let phoneNumber =
      venueDetails.socialLinks?.contactNumber ?? '+910000000000';
    phoneNumber = phoneNumber.replace(/\D/g, ''); // Remove non-digits
    if (phoneNumber.length === 10) {
      // If only local, add country code for India
      phoneNumber = '91' + phoneNumber;
    }
    window.open(`tel:${phoneNumber}`, '_self');
  };

  const handleWhatsApp = () => {
    let phoneNumber =
      venueDetails.socialLinks?.whatsapp ??
      venueDetails.socialLinks?.contactNumber ??
      '+910000000000';
    phoneNumber = phoneNumber.replace(/\D/g, '');
    if (phoneNumber.length === 10) {
      phoneNumber = '91' + phoneNumber;
    }
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };
  const containerRef = useRef(null);

  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };
  return (
    <div
      style={{
        fontFamily: 'Quicksand, sans-serif',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
      }}
    >
      <div style={{ padding: '10px', maxWidth: '400px', margin: '0 auto' }}>
        {/* Hero Section with Navigation */}
        <div style={{ position: 'relative', marginBottom: '8px' }}>
          <div
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '12px',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            {venueDetails.videoUrl ? (
              <video
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              >
                <source src={venueDetails.videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={venueDetails.photoUrl}
                alt="Venue Image"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            )}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background:
                  'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.1))',
              }}
            ></div>

            {/* Navigation Icons */}
            <div
              style={{
                position: 'absolute',
                top: '12px',
                left: '12px',
                right: '12px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <button
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  border: 'none',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => window.history.back()}
              >
                <ArrowLeft size={20} color="white" />
              </button>
              <button
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  border: 'none',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
              >
                <Share2 size={20} color="white" />
              </button>
            </div>

            {/* Rating Badge */}
            <div
              style={{
                position: 'absolute',
                bottom: '12px',
                right: '12px',
                cursor: 'pointer',
              }}
              onClick={scrollToRatings}
            >
              <div
                style={{
                  backgroundColor: '#22c55e',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: '14px',
                }}
              >
                <Star size={14} fill="white" />
                <span>
                  {venueDetails.rating ? venueDetails.rating.toFixed(1) : 0.0}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Business Info */}
        <div style={{ marginBottom: '16px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '8px',
            }}
          >
            <h2
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                margin: 0,
                textAlign: 'left',
              }}
            >
              {venueDetails?.name ?? ''}
            </h2>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span
              style={{
                backgroundColor: isCurrentlyOpen() ? 'green' : 'red',
                color: 'white',
                padding: '4px 12px',
                borderRadius: '8px',
                fontSize: '12px',
              }}
            >
              {isCurrentlyOpen() ? 'Open' : 'Closed'}
            </span>
            <span
              style={{
                color: '#6b7280',
                fontSize: '14px',
                gap: '2px',
                cursor: 'pointer',
              }}
              onClick={openTimingModal}
            >
              Today: {timingData[getCurrentDay()].open} -{' '}
              {timingData[getCurrentDay()].close}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                style={{ color: '#9ca3af', marginLeft: '1px' }}
              >
                <path d="M7 10L12 15L17 10H7Z" />
              </svg>
            </span>
          </div>
        </div>

        {/* Action Buttons */}

        <div style={{ display: 'flex', gap: '4px', marginBottom: '16px' }}>
          <button
            style={{
              flex: 1,
              border: '1px solid #ef4444',
              backgroundColor: 'transparent',
              color: '#ef4444',
              padding: '8px 16px',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              cursor: 'pointer',
            }}
            onClick={handleCall}
          >
            <Phone size={18} />
            <span style={{ fontSize: '14px' }}>Call</span>
          </button>
          <button
            style={{
              flex: 1,
              border: '1px solid #ef4444',
              backgroundColor: 'transparent',
              color: '#ef4444',
              padding: '8px 16px',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              cursor: 'pointer',
            }}
            onClick={openLocationModal}
          >
            <Navigation size={18} />
            <span style={{ fontSize: '14px' }}>Directions</span>
          </button>
          <button
            style={{
              flex: 1,
              border: '1px solid #22c55e',
              backgroundColor: 'transparent',
              color: '#22c55e',
              padding: '8px 16px',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              cursor: 'pointer',
            }}
            onClick={handleWhatsApp}
          >
            <MessageCircle size={18} />
            <span style={{ fontSize: '14px' }}>WhatsApp</span>
          </button>
        </div>

        {/* Social Media Highlights */}
        <div id="gallery-section" style={{ marginBottom: '2px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '38px',
              padding: '4px 0',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {/* Instagram */}
            {venueDetails.socialLinks?.instagram && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '6px',
                }}
                onClick={() =>
                  openSocialModal(
                    'Instagram',
                    venueDetails.socialLinks.instagram
                  )
                }
              >
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background:
                      'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px',
                    cursor: 'pointer',
                  }}
                >
                  <div
                    style={{
                      width: '45px',
                      height: '45px',
                      borderRadius: '50%',
                      backgroundColor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {/* Instagram SVG */}
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                        fill="#E1306C"
                      />
                    </svg>
                  </div>
                </div>
                <span style={{ fontSize: '12px', color: '#4b5563' }}>
                  Instagram
                </span>
              </div>
            )}

            {/* YouTube */}
            {venueDetails.socialLinks?.youtube && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '6px',
                }}
                onClick={() =>
                  openSocialModal('YouTube', venueDetails.socialLinks.youtube)
                }
              >
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: '#FF0000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px',
                    cursor: 'pointer',
                  }}
                >
                  <div
                    style={{
                      width: '45px',
                      height: '45px',
                      borderRadius: '50%',
                      backgroundColor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {/* YouTube SVG */}
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                        fill="#FF0000"
                      />
                    </svg>
                  </div>
                </div>
                <span style={{ fontSize: '12px', color: '#4b5563' }}>
                  YouTube
                </span>
              </div>
            )}

            {/* Facebook */}
            {venueDetails.socialLinks?.facebook && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '6px',
                }}
                onClick={() =>
                  openSocialModal('Facebook', venueDetails.socialLinks.facebook)
                }
              >
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: '#1877F2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px',
                    cursor: 'pointer',
                  }}
                >
                  <div
                    style={{
                      width: '45px',
                      height: '45px',
                      borderRadius: '50%',
                      backgroundColor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {/* Facebook SVG */}
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                        fill="#1877F2"
                      />
                    </svg>
                  </div>
                </div>
                <span style={{ fontSize: '12px', color: '#4b5563' }}>
                  Facebook
                </span>
              </div>
            )}

            {/* Website */}
            {venueDetails.socialLinks?.website && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '6px',
                }}
                onClick={() =>
                  openSocialModal('Website', venueDetails.socialLinks.website)
                }
              >
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: '#000000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px',
                    cursor: 'pointer',
                  }}
                >
                  <div
                    style={{
                      width: '45px',
                      height: '45px',
                      borderRadius: '50%',
                      backgroundColor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <BsGlobe size={24} />
                  </div>
                </div>
                <span style={{ fontSize: '12px', color: '#4b5563' }}>
                  Website
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Offers Section */}
      {offersData && offersData.length > 0 && (
        <div style={{ marginBottom: '2px' }}>
          <h5
            style={{
              fontWeight: 'bold',
              marginBottom: '6px',
              fontSize: '18px',
              textAlign: 'left',
              marginLeft: '16px',
            }}
          >
            Offers
          </h5>

          <div
            style={{
              padding: '12px',
              borderRadius: '12px',
              color: 'white',
              background: 'linear-gradient(135deg, #ef4444, #8b5cf6)',
              position: 'relative',
              overflow: 'hidden',
              cursor: 'pointer',
              marginLeft: '8px',
              marginRight: '8px',
            }}
            onClick={openOffersModal}
          >
            <h6
              style={{
                fontWeight: 'bold',
                marginBottom: '4px',
                fontSize: '16px',
                margin: 0,
                textAlign: 'left',
              }}
            >
              {offersData[0].title}
            </h6>
            <p
              style={{
                marginBottom: '8px',
                opacity: 0.8,
                fontSize: '14px',
                margin: 0,
                textAlign: 'left',
              }}
            >
              {offersData[0].validTo
                ? `Valid till ${new Date(
                    offersData[0].validTo
                  ).toLocaleDateString()}`
                : 'Limited time offer'}
            </p>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '8px',
              }}
            >
              <span style={{ fontSize: '12px', opacity: 0.8 }}>
                Click to see all offers{' '}
              </span>
            </div>
          </div>
        </div>
      )}
      {/* <div 
                        style={{ 
                            padding: '12px',
                            borderRadius: '12px',
                            color: 'white',
                            background: 'linear-gradient(135deg, #ef4444, #8b5cf6)',
                            position: 'relative',
                            overflow: 'hidden',
                            cursor: 'pointer'
                        }}
                        onClick={openOffersModal}
                    >
                        <h6 style={{ fontWeight: 'bold', marginBottom: '4px', fontSize: '16px', margin: 0 , textAlign:'left'}}>1+1 on Cocktails</h6>
                        <p style={{ marginBottom: '8px', opacity: 0.8, fontSize: '14px', margin: 0 , textAlign:'left'}}>Valid till 10 PM today</p>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px' }}>
                            <span style={{ fontSize: '12px', opacity: 0.8 }}>Click to see all offers </span>
                        </div>
                    </div>
                </div> */}

      <h5
        style={{
          fontWeight: 'bold',
          marginBottom: '6px',
          fontSize: '18px',
          textAlign: 'left',
          marginLeft: '16px',
          marginTop: '16px',
        }}
      >
        Photos
      </h5>
      {/* Tab Navigation */}
      <div
        style={{
          padding: '8px',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)', // Creates 3 equal columns
          gap: '8px', // Space between items
          width: '100%',
          maxWidth: '400px', // Optional: constrain max width
          margin: '0 auto', // Center the grid
        }}
      >
        {Object.keys(galleryData).map(tab => (
          <button
            key={tab}
            onClick={() => handleTabChange(tab)}
            style={{
              padding: '8px 0',
              fontSize: '14px',
              fontWeight: activeTab === tab ? '500' : '400',
              color: activeTab === tab ? '#ef4444' : '#6b7280',
              borderBottom: activeTab === tab ? '2px solid #ef4444' : 'none',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              textAlign: 'center', // Center text in grid cell
              width: '100%', // Ensure button fills grid cell
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Photo Gallery */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',

          gap: '8px',
          marginBottom: '24px',
          margin: '0 8px',
        }}
      >
        {currentGallery && currentGallery.length > 0 ? (
          currentGallery.slice(0, 9).map((image, index) => (
            <div
              key={index}
              style={{
                aspectRatio: '1/1',
                overflow: 'hidden',
                borderRadius: '8px',
              }}
            >
              <img
                src={image.photoUrl}
                alt={`Gallery image ${index + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  cursor: 'pointer',
                  transition: 'opacity 0.2s',
                }}
                onClick={() => openModal(index)}
                onMouseOver={e => (e.target.style.opacity = '0.9')}
                onMouseOut={e => (e.target.style.opacity = '1')}
              />
            </div>
          ))
        ) : (
          <div
            style={{
              gridColumn: 'span 3',
              padding: '40px 0',
              textAlign: 'center',
              color: '#6b7280',
              backgroundColor: '#f3f4f6',
              borderRadius: '8px',
            }}
          >
            <p>No photos available</p>
          </div>
        )}
      </div>
      {/* Photo Gallery */}

      {/* Ratings & Reviews Section */}
      <div ref={ratingsRef} style={{ marginTop: '24px', marginBottom: '16px' }}>
        <h5
          style={{
            fontWeight: 'bold',
            marginBottom: '16px',
            fontSize: '18px',
            textAlign: 'left',
            marginLeft: '16px',
          }}
        >
          Ratings & Reviews
        </h5>

        {/* Rating Summary */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '16px',
            borderRadius: '12px',
            marginBottom: '16px',
          }}
        >
          <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
            {venueDetails.rating ? venueDetails.rating.toFixed(1) : '0.0'}
          </span>
          {renderStars(venueDetails.rating)}
          <span style={{ fontSize: '14px', color: '#6b7280' }}>
            (
            {venueDetails?.user_ratings_total > 100
              ? (venueDetails.user_ratings_total / 1000).toFixed(1) + 'k'
              : venueDetails?.user_ratings_total || 0}{' '}
            reviews)
          </span>
        </div>

        {/* Only show if user has NOT reviewed */}

        {/* Reviews List */}
        {/* <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {venueRatings.comments
            .filter(review => !myReview || review.user.id !== userId)
            .map((review, index) => (
              <div
                key={index}
                style={{
                  padding: '16px',
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '12px',
                  }}
                >
                  <img
                    src={review.user.avatar || 'https://via.placeholder.com/40'}
                    alt={review.user.display_name}
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                    }}
                  />
                  <div>
                    <p
                      style={{
                        margin: '0 0 2px 0',
                        fontWeight: '500',
                        fontSize: '14px',
                        textAlign: 'left',
                      }}
                    >
                      {review.user.display_name}
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                      }}
                    >
                      {renderStars(review.rating)}
                      <span style={{ fontSize: '12px', color: '#6b7280' }}>
                        {new Date(review.updatedAt).toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                </div>
                <p
                  style={{
                    margin: 0,
                    fontSize: '14px',
                    lineHeight: '1.5',
                    color: '#374151',
                    textAlign: 'left',
                  }}
                >
                  {review.comment}
                </p>
              </div>
            ))}
          {venueRatings.comments.length === 0 && (
            <div
              style={{
                padding: '24px 16px',
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                textAlign: 'center',
                color: '#6b7280',
              }}
            >
              <p style={{ margin: 0, fontSize: '14px' }}>No reviews yet</p>
            </div>
          )}
        </div> */}
      </div>

      {/* Modal for Image Slideshow */}
      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
          }}
          onClick={closeModal}
        >
          <div
            style={{ position: 'relative' }}
            onClick={e => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                width: '40px',
                height: '40px',
                backgroundColor: 'rgba(0,0,0,0.7)',
                border: 'none',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 1001,
              }}
              onClick={closeModal}
            >
              <X size={20} color="white" />
            </button>

            {/* Navigation Arrows */}
            <button
              style={{
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: '40px',
                height: '40px',
                backgroundColor: 'rgba(0,0,0,0.7)',
                border: 'none',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 1001,
              }}
              onClick={prevImage}
            >
              <ChevronLeft size={20} color="white" />
            </button>

            <button
              style={{
                position: 'absolute',
                right: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: '40px',
                height: '40px',
                backgroundColor: 'rgba(0,0,0,0.7)',
                border: 'none',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 1001,
              }}
              onClick={nextImage}
            >
              <ChevronRight size={20} color="white" />
            </button>

            {/* Main Image */}
            <img
              src={currentGallery[currentImageIndex]?.photoUrl || ''}
              alt={`Gallery image ${currentImageIndex + 1}`}
              style={{
                borderRadius: '8px',
                maxWidth: '90vw',
                maxHeight: '90vh',
                objectFit: 'contain',
              }}
            />

            {/* Image Counter */}
            <div
              style={{
                position: 'absolute',
                bottom: '16px',
                left: '50%',
                transform: 'translateX(-50%)',
                color: 'white',
                padding: '8px 12px',
                borderRadius: '20px',
                backgroundColor: 'rgba(0,0,0,0.7)',
                fontSize: '14px',
              }}
            >
              {currentImageIndex + 1} / {currentGallery.length}
            </div>
          </div>
        </div>
      )}

      <SocialIconModal
        isOpen={socialModal.isOpen}
        onClose={closeSocialModal}
        socialName={socialModal.socialName}
        href={socialModal.href}
      />

      {/* Offers Modal */}
      {isOffersModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            zIndex: 1000,
          }}
          onClick={closeOffersModal}
        >
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '20px 20px 0 0',
              width: '100%',
              maxWidth: '370px',
              maxHeight: '70vh',
              overflow: 'hidden',
              animation: 'slideUp 0.3s ease-out',
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div
              style={{
                padding: '20px',
                borderBottom: '1px solid #e5e7eb',
                position: 'relative',
              }}
            >
              {/* Handle bar */}
              <div
                style={{
                  width: '40px',
                  height: '4px',
                  backgroundColor: '#d1d5db',
                  borderRadius: '2px',
                  margin: '0 auto 16px auto',
                }}
              ></div>

              <h2
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  margin: 0,
                  color: '#1f2937',
                }}
              >
                Current Offers
              </h2>
            </div>

            {/* Modal Content - Swipeable Offers */}
            {/* Modal Content - Swipeable Offers */}
            <div
              style={{
                padding: '20px',
                overflowY: 'auto',
                maxHeight: 'calc(70vh - 100px)',
                position: 'relative',
              }}
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            >
              {offersData && offersData.length > 0 ? (
                <>
                  {/* Current Offer Card */}
                  <div
                    style={{
                      padding: '16px',
                      borderRadius: '12px',
                      color: 'white',
                      background: 'linear-gradient(135deg, #ef4444, #8b5cf6)',
                      position: 'relative',
                      overflow: 'hidden',
                      marginBottom: '16px',
                      minHeight: '120px',
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: 'bold',
                        fontSize: '18px',
                        margin: '0 0 4px 0',
                        textAlign: 'left',
                      }}
                    >
                      {offersData[currentOfferIndex].title}
                    </h3>
                    <p
                      style={{
                        opacity: 0.9,
                        fontSize: '14px',
                        margin: '0 0 8px 0',
                        textAlign: 'left',
                      }}
                    >
                      {offersData[currentOfferIndex].validFrom &&
                      offersData[currentOfferIndex].validTo
                        ? `Valid from ${new Date(
                            offersData[currentOfferIndex].validFrom
                          ).toLocaleDateString()} to ${new Date(
                            offersData[currentOfferIndex].validTo
                          ).toLocaleDateString()}`
                        : 'Limited time offer'}
                    </p>
                    <p
                      style={{
                        opacity: 0.8,
                        fontSize: '12px',
                        margin: 0,
                        textAlign: 'left',
                      }}
                    >
                      {offersData[currentOfferIndex].description}
                    </p>
                  </div>

                  {/* Offer Counter */}
                  {offersData.length > 1 && (
                    <div
                      style={{
                        textAlign: 'center',
                        color: '#6b7280',
                        fontSize: '14px',
                        marginTop: '16px',
                      }}
                    >
                      {currentOfferIndex + 1} / {offersData.length}
                    </div>
                  )}

                  {/* Dots Indicator */}
                  {offersData.length > 1 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '8px',
                        marginTop: '16px',
                      }}
                    >
                      {offersData.map((_, index) => (
                        <div
                          key={index}
                          style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor:
                              index === currentOfferIndex
                                ? '#ef4444'
                                : '#d1d5db',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s',
                          }}
                          onClick={() => setCurrentOfferIndex(index)}
                        />
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '40px 20px',
                    color: '#6b7280',
                  }}
                >
                  <p style={{ fontSize: '16px', margin: '0 0 8px 0' }}>
                    No offers available currently
                  </p>
                  <p style={{ fontSize: '14px', margin: 0, opacity: 0.7 }}>
                    Check back later for exciting deals!
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Location Modal */}
      {islocationModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            zIndex: 1000,
          }}
          onClick={closeLocationModal}
        >
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '20px 20px 0 0',
              width: '100%',
              maxWidth: '370px',
              maxHeight: '70vh',
              overflow: 'hidden',
              animation: 'slideUp 0.3s ease-out',
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div
              style={{
                padding: '20px',
                borderBottom: '1px solid #e5e7eb',
                position: 'relative',
              }}
            >
              {/* Handle bar */}
              <div
                style={{
                  width: '40px',
                  height: '4px',
                  backgroundColor: '#d1d5db',
                  borderRadius: '2px',
                  margin: '0 auto 16px auto',
                }}
              ></div>

              <h2
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  margin: 0,
                  color: '#1f2937',
                }}
              >
                Location & Directions
              </h2>
            </div>

            {/* Modal Content */}
            <div
              style={{
                padding: '20px',
                overflowY: 'auto',
                maxHeight: 'calc(70vh - 100px)',
              }}
            >
              {/* Address Section */}
              <div
                style={{
                  marginBottom: '20px',
                  padding: '16px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '12px',
                  border: '1px solid #e5e7eb',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px',
                    marginBottom: '12px',
                  }}
                >
                  <MapPin
                    size={20}
                    color="#ef4444"
                    style={{ marginTop: '2px' }}
                  />
                  <div style={{ flex: 1 }}>
                    <h3
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        margin: '0 0 4px 0',
                        color: '#1f2937',
                        textAlign: 'left',
                      }}
                    >
                      {locationData.name}
                    </h3>
                    <p
                      style={{
                        fontSize: '14px',
                        color: '#6b7280',
                        margin: '0 0 8px 0',
                        lineHeight: '1.4',
                        textAlign: 'left',
                      }}
                    >
                      {locationData.address}
                    </p>
                    <p
                      style={{
                        fontSize: '12px',
                        color: '#9ca3af',
                        margin: 0,
                        textAlign: 'left',
                      }}
                    >
                      {locationData.landmark}
                    </p>
                  </div>
                </div>
              </div>

              {/* Direction Buttons */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                }}
              >
                {/* Google Maps Button */}
                <button
                  style={{
                    width: '100%',
                    padding: '16px',
                    backgroundColor: '#4285f4',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '500',
                    transition: 'background-color 0.2s',
                  }}
                  onClick={openGoogleMaps}
                  onMouseOver={e =>
                    (e.target.style.backgroundColor = '#3367d6')
                  }
                  onMouseOut={e => (e.target.style.backgroundColor = '#4285f4')}
                >
                  <ExternalLink size={20} />
                  <span>Open in Google Maps</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Timing Modal */}
      {isTimingModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            zIndex: 1000,
          }}
          onClick={closeTimingModal}
        >
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '20px 20px 0 0',
              width: '100%',
              maxWidth: '370px',
              maxHeight: '70vh',
              overflow: 'hidden',
              animation: 'slideUp 0.3s ease-out',
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div
              style={{
                padding: '20px',
                borderBottom: '1px solid #e5e7eb',
                position: 'relative',
              }}
            >
              {/* Handle bar */}
              <div
                style={{
                  width: '40px',
                  height: '4px',
                  backgroundColor: '#d1d5db',
                  borderRadius: '2px',
                  margin: '0 auto 16px auto',
                }}
              ></div>

              <h2
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  margin: 0,
                  color: '#1f2937',
                }}
              >
                Opening Hours
              </h2>
            </div>

            {/* Modal Content */}
            <div
              style={{
                padding: '20px',
                overflowY: 'auto',
                maxHeight: 'calc(70vh - 100px)',
              }}
            >
              {/* Current Status */}

              {/* Weekly Schedule */}
              <div
                style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '12px',
                  padding: '16px',
                  border: '1px solid #e5e7eb',
                }}
              >
                <h3
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    margin: '0 0 16px 0',
                    color: '#1f2937',
                    textAlign: 'left',
                  }}
                >
                  Weekly Schedule
                </h3>

                {Object.entries(timingData).map(([day, timing]) => {
                  const isToday = day === getCurrentDay();
                  return (
                    <div
                      key={day}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 0',
                        borderBottom: '1px solid #e5e7eb',
                        backgroundColor: isToday ? '#fef3c7' : 'transparent',
                        borderRadius: isToday ? '8px' : '0',
                        paddingLeft: isToday ? '12px' : '0',
                        paddingRight: isToday ? '12px' : '0',
                        marginBottom: '4px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <span
                          style={{
                            fontSize: '14px',
                            fontWeight: isToday ? 'bold' : 'normal',
                            color: isToday ? '#92400e' : '#374151',
                            textTransform: 'capitalize',
                            minWidth: '80px',
                            textAlign: 'left',
                          }}
                        >
                          {day}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <span
                          style={{
                            fontSize: '14px',
                            color: timing.isOpen ? '#374151' : '#9ca3af',
                            fontWeight: isToday ? 'bold' : 'normal',
                          }}
                        >
                          {timing.isOpen
                            ? `${timing.open} - ${timing.close}`
                            : 'Closed'}
                        </span>
                        <div
                          style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: timing.isOpen
                              ? '#22c55e'
                              : '#ef4444',
                          }}
                        ></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RudeLounge;
